import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 51DB457C-C26A-4579-8C34-9ED95D270EA4
 * name human-male-height-variant
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male-height-variant.svg
 * tags
 * - Medical / Hospital 
 * - People / Family 
 */
export const HumanMaleHeightVariantIcon = createSvgIcon(<><path d="M7,2C8.78,2 9.67,4.16 8.42,5.42C7.16,6.67 5,5.78 5,4A2,2 0 0,1 7,2M5.5,7H8.5A2,2 0 0,1 10.5,9V14.5H9V22H5V14.5H3.5V9A2,2 0 0,1 5.5,7M19,8H21L18,4L15,8H17V16H15L18,20L21,16H19M22,2H14V4H22M22,20H14V22H22" /></>, 'HumanMaleHeightVariantIcon');
export default HumanMaleHeightVariantIcon